var _defs, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.3;}.cls-2{opacity:0.8;}.cls-3{mask:url(#mask);}.cls-4{fill:#020202;}.cls-5{fill:#10385a;stroke:#d7d7d7;stroke-miterlimit:10;stroke-width:0.5px;}.cls-6{fill:#fff;}.cls-7{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 7,
    y: 27,
    width: 25,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 7,
    y: 27,
    width: 25,
    height: 14,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("image", {
    width: 25,
    height: 14,
    transform: "translate(7 27)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAOCAIAAABVWCAXAAAACXBIWXMAAAsSAAALEgHS3X78AAAB2UlEQVQ4T9VS6UpCURj0bQrqAQqyhRTqAYrcI3M3aIGiMjJs0TKh7VqkFtq+q62kaaSFyw0VQQRFJVGRHqKhIMgK/9ZwOVw4Z+abM3MolH8DGq2Z0dHB7+oSi0QyqbRHLscnl8mkEolQIOjk8drb2pqaGsuoNDTUs1mskeFhrXZubW11c3Nja8uyu7Ozt4tl22I2G42G5eUl9czM0OAgk8GgUut+FZKIxdNTUyCcnp44bm+9Ho/P5yNJ8pkkA4HA0+Pjvdt9dXm5v7+HSRNKJWz+IFddXcXjcpXj4xCy22yeh4dQKBSPx1Op1Ms7MplMMpmMRqN+v//O6Tw+OtITxJhCwWIyKysrvmhBHulo1GqLxXxzfQ1CLBYDP5/Pv76jWCxms9lEIhEOhzHJbrdh6qRK1c3n19bWlPricjiw/ekLHDDhCHKFQiGXy6XTaQwIBoMfvghiRTE6ipbApZQA1aAp5GUyGa1nZy6XC2FFIhHwcVmsuLXX64Xrw4MD5IVAYAoplwp9ABscNhs96nTzBsM6yrs4P3c6HNBFFTarFQno9cSsRoMe4ehXoU/Q6TT0LRIKB/r7kSAeAfiLCwtIp6+3F91hF2fKqHxHa2sLXhwqhgv8lzv+N/EGJvIg3HPvBLcAAAAASUVORK5CYII="
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Map pin - 04") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 33,
    height: 22,
    transform: "translate(3 23)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAWCAYAAABOm/V6AAAACXBIWXMAAAsSAAALEgHS3X78AAACvElEQVRIS53WT0gUYRjH8dcxdVdTMWlTtA6SYoF6qGDLDiJ2kS4hdihJCqRAvXQLUsGbQUGQdlDoGHnypChESHgrKBBUgtAuRoGyVlon+77Mb2waZndnDT6Mve/zPs8z7/xbs7+/b6LgX16usuU8yB2xsIN8ORKBF+tEaShbca9oIWIoRgmOZlCiuJjWeU2lbSZdA44Wx5S4AsdRhRrU4mSIWs1XKb5C62PK54Q1EtaA7dqegT2jY0p6Gk04jyQuoRWXfVo1nlRck9bVKE+J8uYHG0nXQClOoF4JO3ANPbiDPtyVe76/+zTfo/gOra9XvtKwRoKXoMC421eNs2jDdQxgCGN4inE8DzGu+THFD2h9m/JVK3+B8V0afxP2msWNey0b0Y5ePMQEXmEWr7GItyEWNT+r+Amt71W+RuWPq95/TXi7UIZTxr2uNzCMF1jAO6zgM9bxJcS65lcUv6D1w8qXVP4y1XOCTRQZ925uwBX04xnm8AEb+IZtpLCDHz47Gt9W3IbWzSlPv/I2qE7RQRPm3/1gBytxBp24jym8wSq+qsgv7OFPiD3NpxS/qvVTytep/JWq577MIu7ER+Oe2XcV+Ild/PbZ1XhKcRtal30ncrgn3mPNuNd+U4W2jLv9W/r/pubXFJ/TPZHp6bCPmr3LpzGPJRVYVrFPOi5rfElx01o3ZCI+HdneE4MYwRNM4iVmjLvV8zrOaHxScSNaF+09EeGNaa9lF24r8QOM4hEe6ziq8UHFdWldtDdmhG+HTdKCi8bd1qvoxk3c0rFb4+2Ka9G66N+OQCN2q4Jf0YRxv5J1xn3MmnEOF3Rs1nid4hLmMF/RQCP+3xP2cYorYblxz8wWsZ/sah0TGi9XXFzrcv89kaYZx9dQoa+pYh+vqP+HjJOpeKQmMjTkNRXkzWUtfKgmMjSVl2vRoL/dHZt1qm8S0wAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 19.62,
    cy: 33.58,
    rx: 9.77,
    ry: 4.49
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    className: "cls-5",
    d: "M9.43,17.95l.09.23c2.75,6.44,8,13.25,9.57,15.18a.59.59,0,0,0,.93,0c1.55-1.93,6.82-8.74,9.57-15.18a12.19,12.19,0,0,0,1-4.81c0-6.5-4.94-11.78-11-11.78A10.3,10.3,0,0,0,16,2.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25,17.86H23.2a.12.12,0,0,1-.14-.09l-1.37-3.56a.12.12,0,0,0-.14-.1H15.81a.12.12,0,0,0-.14.09l-1.35,3.55a.13.13,0,0,1-.14.1H12.43l.16-.4L16.5,7.51,17.64,4.6a.15.15,0,0,1,.16-.11h1.86a.12.12,0,0,1,.14.09l4.42,11.26L25,17.76Zm-4-5.27L18.68,6.4h0l-2.36,6.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26.66,15.95h1.91v1.91H26.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.6abf8cc7461a2e68b6478f6675da8384.svg";
export { ForwardRef as ReactComponent };